module.exports = __webpack_public_path__ + "img/solution10.739ef815.jpg";